<template>
  <UTabs :items="items" class="w-full md:w-[400px] mx-auto" :ui="{
    list: {
      marker: {
        background: '!bg-orange-500'
      },
      tab: {
        active: 'text-white'
      }
    }
  }">
    <template #item="{ item }">
      <UCard :ui="{
        base: 'h-full mt-6',
        rounded: 'rounded-none md:rounded-lg',
        body: {
          padding: 'p-6'
        }
      }">
        <template #header>
          <div class="space-y-1">
            <p class="text-base font-semibold leading-6 text-gray-900 dark:text-white">
              {{ item.label }}
            </p>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ item.description }}
            </p>
          </div>
        </template>

        <div v-if="item.key === 'login'" class="space-y-4">
          <UForm :schema="schemaLogin" :state="authStore.user" class="space-y-4" @submit="onLogin">
            <UFormGroup label="E-mail" name="email">
              <UInput v-model="authStore.user.email" placeholder="Email adresinizi giriniz" />
            </UFormGroup>

            <UFormGroup label="Şifre" name="password">
              <UInput v-model="authStore.user.password" placeholder="Şifrenizi giriniz" />
            </UFormGroup>

            <div class="flex justify-between items-center">
              <ULink class="font-medium text-sm text-orange-500 hover:text-orange-600" to="/sifremi-unuttum">
                Şifremi unuttum
              </ULink>
            </div>

            <UButton :loading="authStore.loading.login" color="orange" type="submit" block>
              Giriş Yap
            </UButton>

            <div v-if="authStore.apiError.login?.length" class="mt-4">
              <ul class="list-disc text-red-500 pl-4 space-y-1">
                <li v-for="(error, index) in authStore.apiError.login" :key="index">
                  {{ error[0] }}
                </li>
              </ul>
            </div>
          </UForm>
        </div>

        <div v-else-if="item.key === 'register'" class="space-y-4">
          <UForm :schema="schemaRegister" :state="authStore.register" class="space-y-4" @submit="onRegister">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <UFormGroup label="Adınız" name="first_name">
                <UInput v-model="authStore.register.first_name" placeholder="Adınızı giriniz" />
              </UFormGroup>

              <UFormGroup label="Soyadınız" name="surname">
                <UInput v-model="authStore.register.surname" placeholder="Soyadınızı giriniz" />
              </UFormGroup>
            </div>

            <UFormGroup label="E-mail" name="email">
              <UInput v-model="authStore.register.email" placeholder="Email adresinizi giriniz" />
            </UFormGroup>

            <UFormGroup label="Şifre" name="password">
              <UInput v-model="authStore.register.password" placeholder="Şifrenizi giriniz" />
            </UFormGroup>

            <UFormGroup label="Şifre tekrar" name="password_confirmation">
              <UInput v-model="authStore.register.password_confirmation" placeholder="Şifrenizi tekrar giriniz" />
            </UFormGroup>

            <UButton :loading="authStore.loading.register" color="orange" type="submit" block>
              Kaydol
            </UButton>

            <div v-if="authStore.apiError.register?.length" class="mt-4">
              <ul class="list-disc text-red-500 pl-4 space-y-1">
                <li v-for="(error, index) in authStore.apiError.register" :key="index">
                  {{ error[0] }}
                </li>
              </ul>
            </div>
          </UForm>
        </div>
      </UCard>
    </template>
  </UTabs>
</template>

<script setup lang="ts">
const props = defineProps({
  redirect: {
    type: Boolean,
    default: true
  }
})
import { object, string, type InferType } from 'yup'
import type { FormSubmitEvent } from '#ui/types'
const route = useRoute()
const authStore = useAuthStore()
const schemaLogin = object({
  email: string().trim().email('Geçersiz email').required('Zorunlu'),
  password: string()
    .min(8, 'Şifre minimum 8 karakter olmalıdır.')
    .required('Zorunlu')
})

type LoginSchema = InferType<typeof schemaLogin>

const schemaRegister = object({
  first_name: string().trim().required('Ad zorunludur'),
  surname: string().trim().required('Soyad zorunludur'),
  email: string().trim().email('Geçersiz email').required('Zorunlu'),
  password: string()
    .min(8, 'Şifre minimum 8 karakter olmalıdır.')
    .required('Zorunlu'),
  password_confirmation: string()
    .min(8, 'Şifre minimum 8 karakter olmalıdır.')
    .required('Zorunlu')
})

type RegisterSchema = InferType<typeof schemaRegister>

async function onLogin(event: FormSubmitEvent<LoginSchema>) {
  const response = await authStore.login({
    requiredRole: 'user',
    loginEndpoint: '/auth/login/user'
  })
  if (response && props.redirect) {
    const callback =
      typeof route.query.callback === 'string' ? route.query.callback : '/'
    navigateTo(callback)
  }
}

async function onRegister(event: FormSubmitEvent<RegisterSchema>) {
  const response = await authStore.registerUser()
  if (response && props.redirect) {
    const callback =
      typeof route.query.callback === 'string' ? route.query.callback : '/'
    navigateTo(callback)
  }
}

const items = [
  {
    key: 'login',
    label: 'Giriş',
    description: 'Mevcut hesabınıza giriş yapın'
  },
  {
    key: 'register',
    label: 'Kaydol',
    description: 'Yeni bir hesap oluşturun'
  }
]
</script>
